const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';

//require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/pdw_aos.js');
//require('./utilities/pdw_woocommerce.js');

/***
 * Set header height in css var --header-h
 ***/
document.addEventListener("DOMContentLoaded", () => {
    (function () {
        function setHeaderHeight() {
            const header = document.querySelector('#pdw-header');
            if (header) {
                const height = header.offsetHeight;
                document.documentElement.style.setProperty('--header-h', height + 'px');
            }
        }

        // Calculer au chargement
        setHeaderHeight();

        // Recalculer si on redimensionne la fenêtre (responsive)
        window.addEventListener('resize', setHeaderHeight);
    })();
});

/***
 * Parallax
 ***/
document.addEventListener("DOMContentLoaded", () => {
    const parralaxBgs = document.querySelectorAll('.pdw-parallax__bg');
    if (parralaxBgs.length === 0) return;

    const parallaxItems = [];
    parralaxBgs.forEach(bg => {
        const section = bg.closest('section');
        if (section) {
            parallaxItems.push({bg, section});
        }
    });

    const maxTranslatePercent = 10;

    let ticking = false;

    function updateParallax() {
        const windowHeight = window.innerHeight;

        parallaxItems.forEach(item => {
            const rect = item.section.getBoundingClientRect();
            const sectionHeight = rect.height;
            const totalScrollDistance = windowHeight + sectionHeight;
            const currentPosition = windowHeight - rect.top;
            let progress = currentPosition / totalScrollDistance;
            progress = Math.min(Math.max(progress, 0), 1);
            const percentageY = (0.5 - progress) * 2 * maxTranslatePercent;
            item.bg.style.transform = `translate3d(0, ${percentageY}%, 0)`;
        });

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll, {passive: true});
    updateParallax();
});
